// Re-export all hooks for backwards compatibility with @/utils/react-query-hooks
// These can also be imported directly from their domain-specific files

// Accounts
export { useAccountsList, useCreateAccountMutation, useGetAccountById, useGetLastAddedAccountForUser, useGetAllAccountsForUser, useUpdateAccountMutation, useGetAllUpdatesForAccount, type InitialAccountListType, type AccountByIdData, type UpdatesByIdData } from "./accounts"

// Users
export { useUserProfile, useUpdateUserProfile, useUpdateUserFullnameAndAvatarMutation, useUploadUserAvatarMutation, useUpdateUserEmailMutation } from "./users"

// Auth
export { useSignInWithMagicLink, useSignInWithPassword, useResetPassword, useUpdatePassword, useSignInWithProvider, useSignUp } from "./auth"

// Organizations
export {
    useUpdateOrganizationTitleMutation,
    useOrganizationsList,
    useCreateOrganizationMutation,
    useGetOrganizationById,
    useGetTeamMembersInOrganization,
    useGetTeamInvitationsInOrganization,
    useInviteUserMutation,
    useGetOrganizationSubscription,
    useGetAllActiveProducts,
    useGetIsOrganizationAdmin,
    type InitialOrganizationListType,
    type OrganizationByIdData
} from "./organizations"

// Targets
export { useGetAllTargetsForAccount, useAddTargetMutation, useRemoveTargetMutation, useOptimizeTargetsMutation, type TargetsByIdData } from "./targets"

// Activities
export { useGetAllActivitiesForAccount, type ActivitiesByIdData } from "./activities"

// Notifications
export { useNotificationStatus, useHasVerifiedChannel, type NotificationStatusData, type NotificationChannel, type NotificationPreference } from "./notifications"
